import React from 'react';
import './Hero.css';
import TextType from '../TextType/TextType';
import Beams from '../Backgrounds/Beams';
import Lanyard from '../Lanyard/Lanyard';

const Hero = () => {
  return (
    <section id="overview" className="hero">
      <div className="hero-background">
          <Beams
              beamWidth={2}
              beamHeight={15}
              beamNumber={12}
              lightColor="#A855F7"
              speed={2}
              noiseIntensity={1.75}
              scale={0.2}
              rotation={0}
          />
      </div>
      
      <div className="hero-content">
        <TextType 
          text="A 3D Artist's tale."
          as="h1" 
          className="hero-title" 
          cursorCharacter="|" 
          typingSpeed={80}
          pauseDuration={3000}
        />
      </div>

      <div className="hero-visual">
        <Lanyard position={[0, 0, 20]} gravity={[0, -40, 0]} frontImage="/assets/antonino-cuti.png" />
      </div>

    </section>
  );
};

export default Hero;
